<div #cyAcLineContainer class="cy-ac-line-container"></div>